var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "Ordercontent" },
    [
      _c(
        "van-tabs",
        {
          on: { click: _vm.changeTab },
          model: {
            value: _vm.active,
            callback: function($$v) {
              _vm.active = $$v
            },
            expression: "active"
          }
        },
        [
          _c(
            "van-tab",
            { attrs: { title: "新增" } },
            [
              _c(
                "van-cell-group",
                { staticClass: "addressBox" },
                [
                  _c("van-cell", {
                    staticClass: "addressBtn",
                    attrs: {
                      title: "地址",
                      "is-link": "",
                      value: "点击选择地址"
                    },
                    on: {
                      click: function($event) {
                        return _vm.gotoPath("/addressmanage")
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("van-cell", {
                    staticClass: "address",
                    attrs: { value: _vm.saveData.address }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "van-cell-group",
                [
                  _c("van-cell", {
                    attrs: {
                      title: "原供热状态",
                      value: _vm.saveData.hotStatusName
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "van-cell-group",
                [
                  _c("van-cell", {
                    attrs: {
                      title: "操作",
                      "is-link": "",
                      value: _vm.saveData.newStatusName
                    },
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.onStatus($event)
                      }
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "van-col",
                {
                  staticClass: "barBtn",
                  attrs: { span: "24", type: "flex", justify: "space-between" }
                },
                [
                  _c(
                    "van-button",
                    {
                      staticClass: "saveBth",
                      attrs: {
                        round: "",
                        type: "danger",
                        size: "large",
                        disabled: _vm.isSave
                      },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.submit($event)
                        }
                      }
                    },
                    [_vm._v("保存")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "van-tab",
            { attrs: { title: "查看订单" } },
            [
              _vm._l(_vm.OrderList, function(item) {
                return _vm.OrderList
                  ? _c(
                      "van-row",
                      { key: item.ID, attrs: { disabled: item.status != 0 } },
                      [
                        _c(
                          "a",
                          {
                            staticClass: "billBar",
                            attrs: { href: "javascript:;" },
                            on: {
                              click: function($event) {
                                return _vm.gotoOrderInfo(item)
                              }
                            }
                          },
                          [
                            _c("van-col", { attrs: { span: "2" } }, [
                              item.status == "0"
                                ? _c(
                                    "span",
                                    { staticClass: "Status StayColor" },
                                    [_vm._v("待")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              item.status == "1"
                                ? _c(
                                    "span",
                                    { staticClass: "Status Coloring" },
                                    [_vm._v("审")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              item.status == "1"
                                ? _c(
                                    "span",
                                    { staticClass: "Status CompleteColor" },
                                    [_vm._v("已")]
                                  )
                                : _vm._e()
                            ]),
                            _vm._v(" "),
                            _c(
                              "van-col",
                              { attrs: { span: "23", offset: "1" } },
                              [
                                _c(
                                  "van-row",
                                  [
                                    _c(
                                      "van-col",
                                      {
                                        staticClass: "cont",
                                        attrs: { span: "24" }
                                      },
                                      [
                                        _c(
                                          "van-col",
                                          {
                                            staticClass: "address",
                                            attrs: { span: "24" }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(item.roomInfo.roomAddress)
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "van-col",
                                          {
                                            staticClass: "reason",
                                            attrs: { span: "24" }
                                          },
                                          [_vm._v(_vm._s(item.createDate))]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "van-col",
                                      {
                                        staticClass: "statusText",
                                        attrs: { span: "12" }
                                      },
                                      [
                                        _vm._v("原状态："),
                                        _c("span", { staticClass: "orange" }, [
                                          _vm._v(
                                            _vm._s(item.originalStatusText)
                                          )
                                        ])
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "van-col",
                                      {
                                        staticClass: "statusText",
                                        attrs: { span: "12" }
                                      },
                                      [
                                        _vm._v("变更状态："),
                                        _c("span", { staticClass: "orange" }, [
                                          _vm._v(_vm._s(item.changeStatusText))
                                        ])
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "van-col",
                                      {
                                        staticClass: "statusText",
                                        attrs: { span: "18" }
                                      },
                                      [
                                        _vm._v("审核状态："),
                                        _c("span", { staticClass: "orange" }, [
                                          _vm._v(_vm._s(item.statusText))
                                        ])
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    )
                  : _vm._e()
              }),
              _vm._v(" "),
              _vm.OrderList.length == 0
                ? _c(
                    "van-row",
                    { staticClass: "noPayBar" },
                    [
                      _c("van-col", {
                        staticClass: "noPayPC",
                        attrs: { span: "24" }
                      }),
                      _vm._v(" "),
                      _c(
                        "van-col",
                        { staticClass: "text1 orange", attrs: { span: "24" } },
                        [_vm._v("没有变更记录！")]
                      ),
                      _vm._v(" "),
                      _c(
                        "van-col",
                        { staticClass: "text2", attrs: { span: "24" } },
                        [_vm._v("去试试【新增供热状态变更】吧！")]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            2
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "van-popup",
        {
          attrs: { position: "bottom" },
          model: {
            value: _vm.showNewStatus,
            callback: function($$v) {
              _vm.showNewStatus = $$v
            },
            expression: "showNewStatus"
          }
        },
        [
          _c("van-picker", {
            attrs: {
              "show-toolbar": "",
              columns: _vm.newColumns,
              "value-key": "codeLabel"
            },
            on: { confirm: _vm.onConfirm, cancel: _vm.onCancel }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-639b36ca", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-639b36ca","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Stop/Stop.vue
// module id = null
// module chunks = 